import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../../../collection'
import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Subscribes to entity deletion events from the API's onDelete callback and
 * removes entities from the cache when they are deleted.
 *
 * When the context changes, it unsubscribes from the previous observable,
 * calls the callback with the new context, and subscribes to the new observable.
 */
export const subscribeDelete = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    collection: Collection<TTypeParams>,
  ) => {
    const onDelete = collection.api.onDelete
    if (!onDelete) {
      // No subscription support for entity deletions
      return undefined
    }

    return collection.feature.selectors.context.asObservable.pipe(
      // TODO: Note that switchMap will unsubscribe from the previous subscription
      rxjs.switchMap(context =>
        onDelete(context).pipe(
          rxjs.map(id =>
            collection.plugins.cachePlugin.feature.actions.remove
              .from('api.onDelete.subscription')
              .create({ id }),
          ),
        ),
      ),
    )
  },
)
